import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  FiBox,
  FiClock,
  FiRepeat,
  FiTrendingDown,
  FiTrendingUp,
  FiX,
} from "react-icons/fi";

import API from "../../../../../../utils/apiCalling";
import { config } from "../../../../../../utils/apiUrl";

const STOCK_IN = [
  "opening_stock",
  "stock_in",
  "customer_return",
  "adjustment_in",
  "sale_cancelled",
];

const movementLabel = {
  opening_stock: "Opening Stock",
  stock_in: "Stock In",
  stock_out: "Stock Out",
  sale: "Sale",
  sale_cancelled: "Sale Cancelled",
  customer_return: "Customer Return",
  supplier_return: "Supplier Return",
  damaged: "Damaged",
  lost: "Lost",
  adjustment_in: "Adjustment In",
  adjustment_out: "Adjustment Out",
};

const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleString("en-IN");
};

const StockHistoryDrawer = ({
  open,
  product,
  onClose,
  onAdjustStock,
  onReconcileStock,
}) => {
  const api = useMemo(() => new API(), []);

  const [loading, setLoading] =
    useState(false);

  const [history, setHistory] =
    useState([]);

  useEffect(() => {
    if (open && product) {
      loadHistory();
    }
  }, [open, product]);

  const loadHistory = async () => {
    try {
      setLoading(true);

      const response = await api.post(
        config.getInventoryStockMovements,
        {
          page: 1,
          limit: 100,
          productId: product._id,
        }
      );

      if (
        response?.status ===
        "success"
      ) {
        setHistory(
          response.data || []
        );
      } else {
        setHistory([]);
      }
    } catch (e) {
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="inventory-stock-history-overlay">

      <div
        className="inventory-stock-history-backdrop"
        onClick={onClose}
      />

      <div className="inventory-stock-history-drawer">

        {/* Header */}

        <div className="inventory-stock-history-header">

          <div>

            <span>
              PRODUCT HISTORY
            </span>

            <h2>
              {product?.name}
            </h2>

            <small>
              SKU :
              {" "}
              {product?.sku}
            </small>

          </div>

          <button
            onClick={onClose}
          >
            <FiX />
          </button>

        </div>

        {/* Summary */}

        <div className="inventory-stock-history-summary">

          <div>

            <span>
              Current Stock
            </span>

            <strong>
              {product?.stockQty}
            </strong>

          </div>

          <div>

            <span>
              Reserved
            </span>

            <strong>
              {product?.reservedQty || 0}
            </strong>

          </div>

          <div>

            <span>
              Available
            </span>

            <strong>
              {Math.max(
                product?.stockQty -
                  (product?.reservedQty ||
                    0),
                0
              )}
            </strong>

          </div>

        </div>

        {/* Actions */}

        <div className="inventory-stock-history-actions">

          <button
            onClick={() =>
              onAdjustStock(product)
            }
          >
            <FiBox />

            Adjust Stock

          </button>

          <button
            onClick={() =>
              onReconcileStock(product)
            }
          >
            <FiRepeat />

            Reconcile

          </button>

        </div>

        {/* Timeline */}

        <div className="inventory-stock-history-body">

          {loading ? (
            <div className="inventory-stock-history-loading">

              Loading History...

            </div>
          ) : history.length === 0 ? (
            <div className="inventory-stock-history-empty">

              No Stock History Found

            </div>
          ) : (
            history.map((item) => {
              const isIn =
                STOCK_IN.includes(
                  item.movementType
                );

              return (
                <div
                  key={item._id}
                  className="inventory-stock-history-item"
                >
                  <div
                    className={`inventory-stock-history-icon ${
                      isIn
                        ? "in"
                        : "out"
                    }`}
                  >
                    {isIn ? (
                      <FiTrendingUp />
                    ) : (
                      <FiTrendingDown />
                    )}
                  </div>

                  <div className="inventory-stock-history-content">

                    <div className="inventory-stock-history-top">

                      <strong>

                        {movementLabel[
                          item
                            .movementType
                        ]}

                      </strong>

                      <span>

                        {isIn
                          ? "+"
                          : "-"}

                        {item.quantity}

                      </span>

                    </div>

                    <small>

                      Previous :
                      {" "}
                      {
                        item.previousQty
                      }

                      {" → "}

                      {
                        item.newQty
                      }

                    </small>

                    <small>

                      Ref :
                      {" "}
                      {item.referenceNumber ||
                        "-"}

                    </small>

                    <small>

                      {item.notes ||
                        "-"}

                    </small>

                    <div className="inventory-stock-history-footer">

                      <span>

                        <FiClock />

                        {formatDate(
                          item.createdAt
                        )}

                      </span>

                      <span>

                        {
                          item
                            ?.performedBy
                            ?.name
                        }

                      </span>

                    </div>

                  </div>
                </div>
              );
            })
          )}
        </div>

      </div>
    </div>
  );
};

export default StockHistoryDrawer;